import React from 'react'
import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import styled from 'styled-components'
import { Grid } from 'semantic-ui-react'
import { translate, Storage } from 'loankeeper-common/helpers'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { withConstantPermissions } from 'shared'

//@ts-ignore
import LKButton from 'shared/LKButton'
import SelectClientProvider, {
  SelectClientButton,
  AddClientButton,
  ClearClientButton,
  //@ts-ignore
} from 'shared/SelectClientProvider'
import {
  loadClientLinkedFiles,
  loadClientDetails,
  loadClientCashDocs,
  loadClientDelegateCashDocs,
  clientSearch,
  checkReqFields,
} from '../../../store/client'
import { GridContainer } from '../../shared/StyledComponents'
import LKModal, { actions as LKModalActions } from '../../shared/LKModal'
import FormField from '../../shared/newFormElements'

import { actions as ClientEditActions } from '../../ClientEdit'
import ChooseAccountOwnerButton from './ChooseAccountOwnerButton'
import ClientEditButton from './ClientEditButton'
import ClientDetailsTrigger from './ClientDetailsTrigger'
import { IDDOC_SELECT_MODAL, DELEGATE_SELECT_MODAL } from '../constants'
import IDDocSelectModal from '../shared/IDDocSelectModal'
import DelegateSelectModal from '../shared/DelegateSelectModal'

import { ClientAccountPanelProps } from './ClientAccountChoosePanel.types'
import { IddocData } from '../partials/partials.types'
import { ClientDetailsServerData } from 'src/store/client/client.types'
import { AppDispatch } from 'src/store/index.d'
import { ClientCheckReqFieldsParams, ClientSearchAttributes } from '@lk/api'

const GridContainerWrapper = styled(GridContainer)`
  .lk-radio {
    margin-left: 15px;
  }
`

const CLIENT_GROUP = 9
//@ts-ignore
@withConstantPermissions()
//@ts-ignore
@connect(
  (state, props: { form: any }) => ({
    CardNumberSearch: formValueSelector(props.form)(state, 'CardNumberSearch'),
    clientType: formValueSelector(props.form)(state, 'ClientType'),
    clientID: formValueSelector(props.form)(state, 'clientID'),
    clientHash: formValueSelector(props.form)(state, 'clientHash'),
    isClientSelected: formValueSelector(props.form)(state, 'clientIsChosen'),
    delegate: formValueSelector(props.form)(state, 'Delegate'),
  }),
  {
    openModal: LKModalActions.open,
    openClientFillRequiredFieldsConfirmation: (modalParams) =>
      LKModalActions.openConfirmation('ClientFillRequiredFields', {
        message: translate('LKMESSAGE-ERR_FILL_REQUIRED_FIELDS'),
        code: 'ERR_FILL_REQUIRED_FIELDS',
        ...modalParams,
      }),
    openInfo: LKModalActions.openInfo,
    openError: (message: string, code?: string) => LKModalActions.openError(message, code),
    openClientEdit: ClientEditActions.open,
    //@ts-ignore
    openIDDocSelect: () => LKModalActions.open({ name: IDDOC_SELECT_MODAL }),
    //@ts-ignore
    openDelegateSelect: () => LKModalActions.open({ name: DELEGATE_SELECT_MODAL }),
    loadClientLinkedFiles,
    loadClientDetails,
    loadClientCashDocs,
    loadClientDelegateCashDocs,
  },
)
//@ts-ignore
@connect(undefined, (dispatch: AppDispatch) => ({
  clientSearch: (params: ClientSearchAttributes) => dispatch(clientSearch(params)),
  checkReqFields: (params: ClientCheckReqFieldsParams) => dispatch(checkReqFields(params)),
}))
class ClientAccountPanel extends React.Component<ClientAccountPanelProps> {
  state: {
    wrongClient: boolean
    fetching: boolean
    IDScanCount: number
    iddocs?: IddocData[]
  } = {
    wrongClient: false,
    fetching: false,
    IDScanCount: undefined,
  }

  loadedCheckReqFields = {}
  client: any

  componentDidMount() {
    if (this.props.onRef) this.props.onRef(this)
    if (!this.props.isClientSelected) {
      Storage.set('scannedIDCount', '')
    }
    this.props.setChooseClient(this.chooseClient, this.openIDDocDelegateSelect)
  }

  componentWillUnmount() {
    if (this.props.onRef) this.props.onRef(undefined)
  }

  getPanelBackgroundColor = () => {
    if (this.state.wrongClient) {
      return 'red'
    }

    return '#FFFBF0'
  }

  openClientEditConfirmation = (modalParams) => {
    this.props.openClientFillRequiredFieldsConfirmation(modalParams)
  }

  openClientBlackedModal = () => {
    this.props.openInfo(translate('LKMESSAGE-ERR_CLIENT_BLACKLISTED'))
  }

  chooseClient = (personalno: string) => {
    if (!personalno || personalno.trim().length < 1) {
      return
    }

    this.setState({ fetching: true }, async () => {
      await this.searchAndChooseClient(personalno)

      this.setState({ fetching: false })
    })
  }

  handleEnterPress = (e) => {
    if (e.keyCode === 13) {
      this.chooseClient(e.target.value)
    }
  }

  handleSearch = () => {
    this.chooseClient(this.props.CardNumberSearch)
  }

  handleChooseClientRequest = (value: string) => {
    this.chooseClient(value)
  }

  getCheckReqFields = async (ID: number, hash: string) => {
    if (this.loadedCheckReqFields[ID]) {
      return new Promise((resolve) => resolve(this.loadedCheckReqFields[ID]))
    }

    // return Client.checkReqFields({ ClientID: ID, HashSum_ClientID_: hash, ID: CLIENT_GROUP }).then((result) => {
    //   this.loadedCheckReqFields[ID] = result
    //   return result
    // })

    //UPDATED API REQUEST client_oper_api page: checkreqfields
    return this.props
      .checkReqFields({
        ClientID: ID,
        HashSum_ClientID_: hash,
        ID: CLIENT_GROUP,
      })
      .then((result) => {
        const res = { Data: result.payload }
        this.loadedCheckReqFields[ID] = res
        return res
      })
  }

  selectClient = (client: ClientDetailsServerData, checkReqFields: any[], openSelectModal = true) => {
    const { change } = this.props
    const { ID, ClientID, HashSum_ClientID_, hash } = client
    const clientID = ID || ClientID
    const clientHash = HashSum_ClientID_ || hash

    this.setState({ wrongClient: false }, async () => {
      //UPDATED API REQUEST client_oper_api page: checkreqfields
      const reqFields = checkReqFields || (await this.getCheckReqFields(clientID, clientHash))

      const clientDetailsResult = await this.props.loadClientDetails({
        clientId: ID,
        clientHash: HashSum_ClientID_,
      })

      const clientFullDetails = clientDetailsResult.payload

      this.client = clientFullDetails
      //@ts-ignore
      if (reqFields.Data && !reqFields.Data.length) {
        const values = {
          clientWatched: clientFullDetails.Watched === 1 ? 1 : 0,
          clientIsChosen: true,
          clientType: clientFullDetails.ClientTypeID,
          clientID: clientFullDetails.ID,
          clientHash: clientFullDetails.HashSum_ClientID_,
          Name: clientFullDetails.FName,
          Surname: clientFullDetails.LName,
          CityID: clientFullDetails.CityID,
          Address: clientFullDetails.Address,
          IDCardTypeID: clientFullDetails.IDCardTypeID,
          IDCardTypeInit: clientFullDetails.IDCardTypeID,
          IDCardIssuerID: clientFullDetails.IDCardIssuerID,
          FullName: clientFullDetails.FullName,
          DOB: LKDate.from(clientFullDetails.DOB).toString(),
          CardNumber: clientFullDetails.CardNumber,
          IDCardRegDate: LKDate.from(clientFullDetails.IDCardRegDate).toString(),
          CellPhone: clientFullDetails.CellPhone,
          OtherIDNumber: clientFullDetails.IDSerial,
          IDValidityDate: LKDate.from(clientFullDetails.IDValidityDate).toString(),
          CitizenshipID: clientFullDetails.CitizenshipID,
          CardNumberSearch: clientFullDetails.CardNumber,
          Client: clientFullDetails,

          IDCardRegDateCheck: '1',
          IDValidityDateCheck: clientFullDetails.IDValidityDate === '1900-01-01 00:00:00' ? '0' : '1',
          DOBCheck: '1',
        }

        Object.keys(values).forEach((key) => {
          change(key, values[key])
        })

        if (openSelectModal) {
          this.openIDDocDelegateSelect(clientFullDetails)
        }

        this.setState({
          IDScanCount: clientFullDetails.IDScanCount,
        })
        Storage.set('scannedIDCount', clientFullDetails.IDScanCount)
      } else {
        this.openClientEditConfirmation({
          ID: clientFullDetails.ID,
          hash: clientFullDetails.HashSum_ClientID_,
          ClientType: 1,
          clientReqFieldGroupID: 9,
        })
        this.setState({ wrongClient: true })
      }
    })
  }

  searchAndChooseClient = async (searchvalue: string, openSelectModal = true) => {
    // 1. Request client search
    // 2. Check if client exactly one client is found
    // 3. Request client details
    // 5. Request client required fields check
    // 6. Check if client is valid
    try {
      const params = {
        page: 'searchexact',
        searchfield: 'personalno',
        searchflags: Number(this.props.clientType) === 1 ? '1000001' : '0010001',
        searchvalue,
      }
      // const { Data: Clients } = await Client.search(params)

      //UPDATED API REQUEST 'client_search'
      //@ts-ignore
      const Clients = await this.props.clientSearch(params).unwrap()

      if (Clients.length === 1) {
        this.setState({ wrongClient: false })

        return this.selectClient(Clients[0], null, openSelectModal)
      }
    } catch (err) {
      this.setState({ fetching: false }, () => {
        this.props.openError(
          translate(`LKMESSAGE-${err.text || err.message}`) || translate('frm_company_delegate_select-pan_1'),
          translate(`LKMESSAGE-${err.text || err.message}`),
        )
      })
    }

    this.setState({ wrongClient: true })
  }

  handleClose = () => {
    if (this.client) {
      this.searchAndChooseClient(this.client.CardNumber, false)
    }
  }

  handleClientFillByHandClick = () => {
    this.props.clearFields(
      false,
      false,
      'clientType',
      'Name',
      'Surname',
      'Address',
      'FullName',
      'DOB',
      'CardNumber',
      'IDCardRegDate',
      'CellPhone',
      'OtherIDNumber',
      'IDValidityDate',
      'clientID',
      'clientHash',
    )

    this.props.change('Name', '')
    this.props.change('Surname', '')
    this.props.change('Address', '')
    this.props.change('FullName', '')
    this.props.change('DOB', '')
    this.props.change('CardNumber', '')
    this.props.change('IDCardRegDate', '')
    this.props.change('CellPhone', '')
    this.props.change('OtherIDNumber', '')
    this.props.change('IDValidityDate', '')
    this.props.change('clientID', '')
    this.props.change('clientHash', '')

    this.props.change('clientIsChosen', false)
    this.props.change('CityID', 1)
    this.props.change('IDCardTypeID', 1)
    this.props.change('IDCardIssuerID', 1)
    this.props.change('CitizenshipID', 1)
    this.props.change('CardNumberSearch', '')
    this.props.change('Client', null)
    this.props.change('IDDoc', null)
    this.props.change('Delegate', null)
    this.props.change('LinkedFiles', null)
  }

  handleChooseOwner = (client: ClientDetailsServerData) => {
    this.client = client

    this.props.change('clientWatched', client.Watched === 1 ? 1 : 0)

    this.openIDDocDelegateSelect(client)
  }

  handleSelectClient = (client: ClientDetailsServerData, checkReqFields = null) => {
    this.props.change('CardNumberSearch', client.CardNumber)
    this.selectClient(client, checkReqFields)
  }

  openIDDocDelegateSelect = async (client: ClientDetailsServerData) => {
    const clientType = (client && client.ClientTypeID) || this.props.clientType
    const clientID = (client && client.ID) || this.props.clientID
    const clientHash = (client && client.HashSum_ClientID_) || this.props.clientHash

    const isIndividual = clientType.toString() === '1'
    const { payload: iddocs } = await (isIndividual
      ? this.props.loadClientCashDocs({
          clientId: clientID,
          clientHash: clientHash,
        })
      : this.props.loadClientDelegateCashDocs({
          clientId: clientID,
          clientHash: clientHash,
        }))

    this.setState({ iddocs })

    if (isIndividual) {
      this.props.openIDDocSelect()
    } else if (iddocs && iddocs.length) {
      this.props.openDelegateSelect()
    } else {
      this.handleClientFillByHandClick()
      this.props.openError(translate('frm_company_delegate_select-pan_1'))
    }

    const clientLinkedFilesResult = await this.props.loadClientLinkedFiles({
      clientId: clientID,
      clientHash,
    })

    if (loadClientLinkedFiles.fulfilled.match(clientLinkedFilesResult)) {
      this.props.change('LinkedFiles', clientLinkedFilesResult.payload)
    }
  }

  handleIDDocSelect = (iddoc: IddocData) => {
    this.props.change('IDDoc', iddoc)
  }

  handleIDDocSelectCancel = () => {
    if (this.state.iddocs.length) {
      this.props.change('IDDoc', this.state.iddocs.find((d) => d.DFDoc === 1) || this.state.iddocs[0])
    }
  }

  handleDelegateSelect = async (delegate) => {
    const clientDetailsResult = await this.props.loadClientDetails({
      clientId: delegate.RLClientID,
      clientHash: delegate.HashSum_RLClientID_,
    })

    if (loadClientDetails.fulfilled.match(clientDetailsResult)) {
      this.props.change('Delegate', clientDetailsResult.payload)
    }

    const clientCashDocsResult = await this.props.loadClientCashDocs({
      clientId: delegate.RLClientID,
      clientHash: delegate.HashSum_RLClientID_,
    })

    if (loadClientCashDocs.fulfilled.match(clientCashDocsResult)) {
      this.props.change(
        'IDDoc',
        clientCashDocsResult.payload.find((d) => d.ID === delegate.IDDocID),
      )
    }
  }

  handleDelegateSelectCancel = () => {
    if (this.state.iddocs.length) {
      const delegate = this.state.iddocs.find((d) => d.DFDoc === 1) || this.state.iddocs[0]
      this.handleDelegateSelect(delegate)
    }
  }

  handleClientTypeChange = () => {
    this.handleClientFillByHandClick()
  }

  clientTypeOptions = [
    { value: '1', label: translate('frm_acc_entry_add-opt_ind') },
    { value: '3', label: translate('frm_acc_entry_add-opt_comp') },
  ]

  render() {
    const {
      disabled,
      client,
      permissions,
      disableHandfill,
      clientID,
      clientHash,
      clientType,
      delegate,
      CardNumberSearch,
      embedded,
      initialClient,
      initialIDDoc,
      initialDelegate,
    } = this.props
    const { IDScanCount } = this.state

    const isCompany = clientType === '3'
    const isBorrowerOrg = initialClient && initialClient.ClientTypeID.toString() === '3'
    console.log(clientType)
    return (
      <SelectClientProvider
        pin={CardNumberSearch}
        onSelectClient={this.handleSelectClient}
        clientGroup={CLIENT_GROUP}
        clientTypes={clientType}
        editClientProps={{
          name: 'ClientEditInOrderAdd',
        }}
        clientSearchFlags={Number(clientType) === 1 ? '1000001' : '0010001'}
      >
        {/* @ts-ignore */}
        <LKModal.Confirmation
          name="ClientFillRequiredFields"
          onConfirm={(modalParams) => this.props.openClientEdit({ name: 'ClientEditInOrderAdd', ...modalParams })}
        />

        {/* @ts-ignore */}
        <IDDocSelectModal
          iddocs={this.state.iddocs}
          onSelect={this.handleIDDocSelect}
          onCancel={this.handleIDDocSelectCancel}
          openIDDoc={this.props.openIDDoc}
        />

        <DelegateSelectModal
          //@ts-ignore
          delegates={this.state.iddocs}
          onSelect={this.handleDelegateSelect}
          onCancel={this.handleDelegateSelectCancel}
          linkedfiles={this.props.linkedfiles}
        />

        <GridContainerWrapper style={{ backgroundColor: this.getPanelBackgroundColor() }}>
          <Grid>
            <Grid.Row>
              <Grid.Column verticalAlign="middle" width={4}>
                {/* @ts-ignore */}
                <FormField
                  type="radio"
                  name="ClientType"
                  selectedValue={clientType}
                  options={this.clientTypeOptions}
                  customOnChange={(data) => {
                    this.props.handleTabChange(data)
                    this.handleClientTypeChange()
                  }}
                />
              </Grid.Column>

              <Grid.Column width={5} className="u-flex u-directionRow">
                {/* @ts-ignore */}
                <FormField
                  autoFocus
                  loading={this.state.fetching}
                  onKeyDown={this.handleEnterPress}
                  type="text" // "number"
                  dontParseToInt
                  maxLength="20"
                  name="CardNumberSearch"
                  isPersonalNo
                  disabled={this.state.fetching || disabled || (embedded && isBorrowerOrg && isCompany)}
                />
                <LKButton
                  alias="binoculars"
                  className="u-marginLeft-5"
                  onClick={this.handleSearch}
                  disabled={embedded && isBorrowerOrg && isCompany}
                />

                <LKButton
                  alias="iddoc"
                  onClick={this.openIDDocDelegateSelect}
                  disabled={!this.props.isClientSelected}
                />
                <SelectClientButton onlyIcon disabled={embedded && isBorrowerOrg && isCompany} />
                <ClearClientButton
                  onClick={this.handleClientFillByHandClick}
                  disabled={disabled || disableHandfill || embedded}
                />
              </Grid.Column>

              <Grid.Column textAlign="right" width={7}>
                {permissions.VIEW_CLIENT && (
                  //@ts-ignore
                  <ChooseAccountOwnerButton
                    openClientEditConfirmation={this.openClientEditConfirmation}
                    openClientBlackedModal={this.openClientBlackedModal}
                    change={this.props.change}
                    cashOut={this.props.cashOut}
                    form={this.props.form}
                    disabled={disabled}
                    client={client}
                    onChoose={this.handleChooseOwner}
                    onChooseClientRequest={this.handleChooseClientRequest}
                    embedded={embedded}
                    initialClient={initialClient}
                    initialIDDoc={initialIDDoc}
                    initialDelegate={initialDelegate}
                  />
                )}

                <AddClientButton
                  permission="ADD_CLIENT"
                  isAllowed={(providerClientType) => providerClientType === '1'}
                  disabled={disabled || embedded}
                />

                {permissions.EDIT_CLIENT && this.props.clientType === '1' && (
                  <ClientEditButton
                    openClientEdit={this.props.openClientEdit}
                    disabled={disabled}
                    client={client}
                    form={this.props.form}
                    searchAndChooseClient={this.searchAndChooseClient}
                  />
                )}

                {permissions.VIEW_CLIENT && (
                  <ClientDetailsTrigger
                    clientID={isCompany && delegate ? delegate.ID : clientID}
                    clientHash={isCompany && delegate ? delegate.HashSum_ClientID_ : clientHash}
                    client={isCompany && delegate ? delegate : client}
                    //@ts-ignore
                    FormName={this.props.form}
                    IDScanCount={
                      (isCompany && delegate ? delegate.IDScanCount : IDScanCount) || Storage.get('scannedIDCount')
                    }
                    onClose={this.handleClose}
                  />
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </GridContainerWrapper>
      </SelectClientProvider>
    )
  }
}

export default ClientAccountPanel
